import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import * as Icon from "react-feather";
import { connect } from "react-redux";
import { reorderFiles } from "../../redux/slices/editorSlice";
import { CircularProgress } from "@mui/material";

const mapStateToProps = (state) => {
  return {
    activeTab: state.activeTab,
    unsaved_files: state.unsaved_files,
  };
};

const mapDispatchToProps = (dispatch) => ({
  reorderFiles: (files) => dispatch(reorderFiles(files)),
});

const EditorTabs = ({
  files,
  reorderFiles,
  activeTab,
  unsaved_files,
  setFileName,
  running_queries,
  saveCheck,
}) => {
  const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const newItems = reorder(
      files,
      result.source.index,
      result.destination.index
    );

    reorderFiles(newItems);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided) => (
          <div
            ref={provided.innerRef}
            className="editor-tab-container"
            style={{ overflowX: "auto" }}
            {...provided.droppableProps}
          >
            {files.map((file, index) => (
              <Draggable key={file} draggableId={file} index={index}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={`dragged-tab btn ${
                      activeTab === file ? "active" : ""
                    }`}
                    variant={"tab"}
                    onClick={() => setFileName(file, true)}
                    id={file}
                    style={{
                      ...provided.draggableProps.style,
                      height: "24px"
                    }}
                  >
                {Object.keys(running_queries).includes(file) ? (
                      <CircularProgress
                        size={11}
                        color="#fff"
                        sx={{
                          marginRight: "5px",
                        }}
                      />
                    ) : (
                      <Icon.File size={11} style={{ 
                        margin: "0 5px",
                        color: activeTab === file ? "blue" : "#6a737d"  // Blue for active tab, gray for inactive
                      }} />
                    )}
                    {file.startsWith("untitled-") ? (
                      <i>{file.split("/").pop()}</i>
                    ) : (
                      file.split("/").pop()
                    )}

                    {Object.keys(unsaved_files).includes(file) ? (
                      <span style={{
                        color: "#fbbf24", // Orange/amber color
                        fontSize: "18px", // Larger font size
                        fontWeight: "bold",
                        marginLeft: "6px",
                        display: "inline-flex",
                        alignItems: "center",
                        verticalAlign: "middle",
                        lineHeight: 1
                      }}>•</span>
                    ) : ""}

                    <Icon.X
                      size={12}
                      onClick={(e) => saveCheck(e, file)}
                      style={{ marginLeft: "10px", cursor: "pointer" }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = "rotate(90deg)";
                        e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.05)";
                        e.currentTarget.style.transition = "transform 0.3s ease";
                        e.currentTarget.style.borderRadius = "50%";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = "";
                        e.currentTarget.style.backgroundColor = "";
                        e.currentTarget.style.transition = "";
                        e.currentTarget.style.borderRadius = "";
                      }}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(EditorTabs);